<template>
  <span class="sum-wrap">
    数据更新时间：
    <span class="sum">{{ storeStockStatistics?.updateTime || '' }}</span>
  </span>
</template>

<script setup lang="ts">
import { ref, computed, useCurrentAppInstance, type AppEventListeners } from '@zto/zpage'
import dayjs from 'dayjs'

const props = withDefaults(
  defineProps<{
    contextData?: any
    listeners?: AppEventListeners
  }>(),
  {}
)

const app = useCurrentAppInstance()
const appApi = app.api

// 统计
const storeStockStatistics: any = ref({})

const getData = async (searchParams: any) => {
  // storeStockStatistics.value = await appApi.request({
  //   url: '',
  //   data: searchParams
  // })
  storeStockStatistics.value = {
    updateTime: dayjs().format('YYYY-MM-DD HH:mm:ss')
  }
}

// 注册微件事件监听
app.useEventListeners(props.listeners, {
  storeStockSearchOn: async (e: any) => {
    console.info('🚀 ~ file:CCabinetStockUpdateTime method:storeStockSearchOn', e)
    getData(e)
  }
})
</script>

<style lang="scss" scoped>
.sum-wrap {
  margin-left: 12px;
}

.sum {
  color: #333;
  font-weight: bolder;
  font-size: 18px;
}
</style>
